import React from 'react';
import ProductLink from '../models/ProductLink';
import ReactHtmlParser from 'react-html-parser';
// TODO: use lineClamp helper instead of ClampLines
import ClampLines from 'react-clamp-lines';
import ImageUtils from '@gik/core/utils/ImageUtils';

interface ProductLinkCardProps {
  productLink: ProductLink;
  showDescription?: boolean;
}

export default class ProductLinkCard extends React.PureComponent<ProductLinkCardProps> {
  render() {
    const productUrl = `/products/${this.props.productLink.slug}`;
    return (
      <div className={`product-link-card`}>
        <a href={productUrl} className="row-1">
          <div
            className="image"
            style={{
              backgroundImage: ImageUtils.imageOrNotFoundGradient(
                this.props.showDescription
                  ? this.props.productLink.smallImageUrl
                  : this.props.productLink.mediumImageUrl
              ),
            }}
          ></div>
          {this._renderTitle()}
        </a>
        <div className="row-2">
          <div className="content">
            <a href={productUrl}>{this._renderTitle()}</a>
            {this.props.showDescription && (
              <div className="description">{ReactHtmlParser(this.props.productLink.shortDescription)}</div>
            )}
          </div>
        </div>
      </div>
    );
  }

  private _renderTitle() {
    return (
      <ClampLines
        text={this.props.productLink.title}
        id={this.props.productLink.slug}
        lines={this.props.showDescription ? 2 : 4}
        ellipsis="..."
        buttons={false}
        className="title"
        innerElement="p"
      />
    );
  }
}
